import { combineReducers } from 'redux';
import currentUserData from './setCurrentUser';
import toggleSideNav from './toggleSideNav';

export default combineReducers({
  currentUserData,
  toggleSideNav,
});
